import { QueryClientProvider } from '@tanstack/react-query';
import { MessageProvider } from '@/components/ui/message';
import { NotificationProvider } from '@/components/ui/notification';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from '@/shared/api/query-client';
import type { createAppRouter } from '@/router';
import { AppConfigProvider } from '@/app-config/runtime/AppConfigProvider';
import { BrandingProvider } from '@/app-config/runtime/BrandingProvider';
import type { WebAppConfig } from '@/app-config/model/types';
import { AuthLoadingController } from '@/features/auth';
import { AppErrorBoundary } from '@/shared/components/AppErrorBoundary';

export function App({
  router,
  profile,
}: {
  router: ReturnType<typeof createAppRouter>;
  profile: WebAppConfig;
}) {
  return (
    <AppErrorBoundary>
      <AppConfigProvider config={profile}>
        <BrandingProvider branding={profile.branding}>
          <MessageProvider>
            <NotificationProvider>
              <QueryClientProvider client={queryClient}>
                <AuthLoadingController>
                  <RouterProvider router={router} />
                </AuthLoadingController>
              </QueryClientProvider>
            </NotificationProvider>
          </MessageProvider>
        </BrandingProvider>
      </AppConfigProvider>
    </AppErrorBoundary>
  );
}
